import { useState } from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';

import { CtaButton } from '@tassomutuo-backoffice/ui';
import { TeamGroup } from '@tassomutuo-backoffice/types';
import TeamsDetailGroupFormModal from './TeamsDetailGroupFormModal';
import TeamsDetailGroupTable from './TeamsDetailGroupTable';

interface IProps {
  teamGroups: TeamGroup[];
  isPendingTeamGroups: boolean;
  createTeamGroup: (
    teamGroupData: Omit<TeamGroup, 'id' | 'team'>
  ) => Promise<void>;
  onDeleteTeamGroup: (group: TeamGroup) => void;
  onManageGroupLeaders: (group: TeamGroup) => void;
  onViewGroupDetails: (group: TeamGroup) => void;
  disabled: boolean;
}

const TeamsDetailGroupSection = ({
  createTeamGroup,
  onDeleteTeamGroup,
  teamGroups,
  isPendingTeamGroups,
  onManageGroupLeaders,
  onViewGroupDetails,
  disabled,
}: IProps) => {
  const [openFormGroupModal, setOpenFormGroupModal] = useState(false);

  return (
    <>
      <Paper sx={{ bgcolor: 'white', p: 2, borderRadius: 2, mt: 4 }}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Gruppi del team
          </Typography>
          <CtaButton
            variant="contained"
            onClick={() => setOpenFormGroupModal(true)}
            disabled={disabled}
          >
            Aggiungi gruppo
          </CtaButton>
        </Box>
        <Divider sx={{ my: 2 }} />
        <TeamsDetailGroupTable
          isPending={isPendingTeamGroups}
          teamGroups={teamGroups || []}
          onDeleteIconClick={onDeleteTeamGroup}
          onManageGroupLeaders={onManageGroupLeaders}
          onViewGroupDetails={onViewGroupDetails}
          disabled={disabled}
        />
      </Paper>
      {openFormGroupModal && (
        <TeamsDetailGroupFormModal
          handleClose={() => setOpenFormGroupModal(false)}
          createTeamGroup={createTeamGroup}
          disabled={disabled}
        />
      )}
    </>
  );
};

export default TeamsDetailGroupSection;
